import { createSlice } from '@reduxjs/toolkit';

export interface Document {
  loading: boolean;
  error: string | null;
  data: any;
  entityDocuments: any;
  entityDocumentsById: any;
  presignedURL: string;
  documentApproved: boolean | null;
  documentRejected: boolean | null;
}

export const documentInitialState: Document = {
  data: null,
  loading: false,
  error: null,
  entityDocuments: null,
  entityDocumentsById: {},
  presignedURL: '',
  documentApproved: null,
  documentRejected: null,
};

export const agencyDocumentSlice = createSlice({
  name: 'agencyDocuments',
  initialState: documentInitialState,
  reducers: {
    storeDocumentRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    },
    setDocumentStoreSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    setDocumentStoreFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
    updateDocumentRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    },
    setDocumentUpdateSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    setDocumentUpdateFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
    setDataReset: (state) => {
      state.data = null;
      state.loading = true;
      state.documentApproved = null;
      state.documentRejected = null;
      state.entityDocuments = null;
      state.entityDocumentsById = {};
    },
    getDocumentByEntityRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getDocumentByEntitySuccess: (state, action) => {
      state.loading = false;
      state.entityDocuments = action.payload;
    },
    getDocumentByEntityFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getDocumentByEntityForObjectRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getDocumentByEntityForObjectSuccess: (state, action) => {
      state.loading = false;
      state.entityDocuments = action.payload;
      state.entityDocumentsById = {
        ...state.entityDocumentsById,
        [action.payload.entityId]: action.payload.data,
      };
    },
    getDocumentByEntityForObjectFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getPresignedURLRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getPresignedURLSuccess: (state, action) => {
      state.loading = false;
      state.presignedURL = action.payload;
    },
    getPresignedURLFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    approveDocumentRequest: (state, action) => {
      state.loading = true;
      state.documentApproved = null;
    },
    setApproveDocumentSuccess: (state, action) => {
      state.loading = false;
      state.documentApproved = true;
    },
    setApproveDocumentFailure: (state, action) => {
      state.loading = false;
      state.documentApproved = false;
    },
    rejectDocumentRequest: (state, action) => {
      state.loading = true;
      state.documentRejected = null;
    },
    setRejectDocumentSuccess: (state, action) => {
      state.loading = false;
      state.documentRejected = true;
    },
    setRejectDocumentFailure: (state, action) => {
      state.loading = false;
      state.documentRejected = false;
    },
  },
});

export const {
  rejectDocumentRequest,
  setRejectDocumentSuccess,
  setRejectDocumentFailure,
  approveDocumentRequest,
  setApproveDocumentSuccess,
  setApproveDocumentFailure,
  setDataReset,
  updateDocumentRequest,
  setDocumentUpdateSuccess,
  setDocumentUpdateFailure,
  storeDocumentRequest,
  setDocumentStoreSuccess,
  setDocumentStoreFailure,
  getDocumentByEntityRequest,
  getDocumentByEntitySuccess,
  getDocumentByEntityFailure,
  getDocumentByEntityForObjectRequest,
  getDocumentByEntityForObjectSuccess,
  getDocumentByEntityForObjectFailure,
  getPresignedURLRequest,
  getPresignedURLSuccess,
  getPresignedURLFailure,
} = agencyDocumentSlice.actions;

export default agencyDocumentSlice.reducer;
